var _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteSetupProject1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-106"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 275.93,
    width: 29.42,
    height: 106.47,
    transform: "translate(206.35 658.33) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.56 382.4 88.47 382.4 88.47 367.9 98.91 367.9 93.56 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.45,
    y: 275.93,
    width: 29.42,
    height: 106.47,
    transform: "translate(594.32 658.33) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.47,
    y: 275.93,
    width: 198.43,
    height: 97.57,
    transform: "translate(375.36 649.43) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.42,
    y: 280.25,
    width: 190.53,
    height: 26.76,
    transform: "translate(375.36 587.27) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,288.57h78.47a29.23,29.23,0,0,0,21.22-9.13H127.22A29.25,29.25,0,0,0,148.45,288.57Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.8 382.4 286.9 382.4 286.9 367.9 276.46 367.9 281.8 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.42,
    y: 311.34,
    width: 190.53,
    height: 26.76,
    transform: "translate(375.36 649.43) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,319.65h78.47a29.23,29.23,0,0,0,21.22-9.13H127.22A29.25,29.25,0,0,0,148.45,319.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.42,
    y: 342.42,
    width: 190.53,
    height: 26.76,
    transform: "translate(375.36 711.6) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.45,350.73h78.47a29.26,29.26,0,0,0,21.22-9.12H127.22A29.28,29.28,0,0,0,148.45,350.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.13,
    y: 101,
    width: 116.04,
    height: 143.71,
    transform: "translate(284.3 345.71) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.93,
    y: 101,
    width: 125.87,
    height: 143.71,
    transform: "translate(267.73 345.71) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.56,
    y: 120.47,
    width: 122.62,
    height: 104.78,
    transform: "translate(306.72 38.99) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.1,
    y: 99.42,
    width: 157.24,
    height: 141.71,
    transform: "translate(715.44 340.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.97,
    y: 99.42,
    width: 159.44,
    height: 141.71,
    transform: "translate(709.37 340.54) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.25,
    y: 241.13,
    width: 145.09,
    height: 7.68,
    transform: "translate(727.59 489.93) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.9,
    y: 241.13,
    width: 136.66,
    height: 7.68,
    transform: "translate(674.46 489.93) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.62,
    y: 96.34,
    width: 130.14,
    height: 147.87,
    transform: "translate(524.96 -184.42) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.56 235.34 356.17 105.2 332.85 105.2 382.24 235.34 405.56 235.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.84,226.24a.52.52,0,0,0,.52-.52V109.07a.52.52,0,1,0-1,0V225.72A.51.51,0,0,0,425.84,226.24Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.23 235.34 327.84 105.2 318.75 105.2 368.14 235.34 377.23 235.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.68 235.34 306.29 105.2 297.19 105.2 346.59 235.34 355.68 235.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.05,
    y: 169.9,
    width: 130.14,
    height: 0.73,
    transform: "translate(451.39 -110.85) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 110.45 430.84 110.45 431.37 107.45 274.13 107.45 273.6 110.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 113.67 430.84 113.67 431.37 110.67 274.13 110.67 273.6 113.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 116.89 430.84 116.89 431.37 113.89 274.13 113.89 273.6 116.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 120.11 430.84 120.11 431.37 117.12 274.13 117.12 273.6 120.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 123.34 430.84 123.34 431.37 120.34 274.13 120.34 273.6 123.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 126.56 430.84 126.56 431.37 123.56 274.13 123.56 273.6 126.56",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 129.78 430.84 129.78 431.37 126.78 274.13 126.78 273.6 129.78",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 133 430.84 133 431.37 130 274.13 130 273.6 133",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 136.22 430.84 136.22 431.37 133.22 274.13 133.22 273.6 136.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 139.44 430.84 139.44 431.37 136.45 274.13 136.45 273.6 139.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 142.67 430.84 142.67 431.37 139.67 274.13 139.67 273.6 142.67",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 145.89 430.84 145.89 431.37 142.89 274.13 142.89 273.6 145.89",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 149.11 430.84 149.11 431.37 146.11 274.13 146.11 273.6 149.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 152.33 430.84 152.33 431.37 149.33 274.13 149.33 273.6 152.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 155.55 430.84 155.55 431.37 152.56 274.13 152.56 273.6 155.55",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 158.78 430.84 158.78 431.37 155.78 274.13 155.78 273.6 158.78",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 162 430.84 162 431.37 159 274.13 159 273.6 162",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 165.22 430.84 165.22 431.37 162.22 274.13 162.22 273.6 165.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 168.44 430.84 168.44 431.37 165.44 274.13 165.44 273.6 168.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 171.66 430.84 171.66 431.37 168.66 274.13 168.66 273.6 171.66",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 174.88 430.84 174.88 431.37 171.88 274.13 171.88 273.6 174.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 178.11 430.84 178.11 431.37 175.11 274.13 175.11 273.6 178.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 181.33 430.84 181.33 431.37 178.33 274.13 178.33 273.6 181.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.6 184.55 430.84 184.55 431.37 181.55 274.13 181.55 273.6 184.55",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.71,260.33c0,8.62-11.32,15.6-25.28,15.6s-25.28-7-25.28-15.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.27,260.33c0,8.62-11.32,15.6-25.28,15.6s-25.29-7-25.29-15.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.6,
    y: 284.37,
    width: 18.1,
    height: 92.19,
    transform: "translate(759.29 660.93) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.94,
    y: 376.56,
    width: 89.28,
    height: 5.84,
    transform: "translate(681.17 758.96) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.47,
    y: 284.37,
    width: 78.13,
    height: 92.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.58,
    y: 295.72,
    width: 63.89,
    height: 30.23,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.58,
    y: 334.97,
    width: 63.89,
    height: 30.23,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.59,
    y: 308.76,
    width: 17.88,
    height: 4.15,
    rx: 1.66,
    transform: "translate(663.06 621.66) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.59,
    y: 348.02,
    width: 17.88,
    height: 4.15,
    rx: 1.66,
    transform: "translate(663.06 700.18) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-106"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-106",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Website--inject-106"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.57,
    y: 176.92,
    width: 1,
    height: 19.2,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.57,
    y: 203.37,
    width: 1,
    height: 8.82,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.72,
    y: 129.31,
    width: 281.15,
    height: 184.1,
    rx: 10.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.77,
    y: 84.31,
    width: 177.05,
    height: 274.1,
    rx: 7.05,
    transform: "translate(9.93 452.65) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.56,281.42v28.47H263V281.42a10,10,0,0,0-10-10H209.53A10,10,0,0,0,199.56,281.42Z",
    style: {
      fill: "#407BFF",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.78,281.42v28.47h63.47V281.42a10,10,0,0,0-10-10H289.75A10,10,0,0,0,279.78,281.42Z",
    style: {
      fill: "#407BFF",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.33,281.42v28.47h63.48V281.42a10,10,0,0,0-10-10H129.31A10,10,0,0,0,119.33,281.42Z",
    style: {
      fill: "#407BFF",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.29,150.67H340.7a2.55,2.55,0,0,0,2.55-2.55h0a2.55,2.55,0,0,0-2.55-2.55H322.29a2.56,2.56,0,0,0-2.55,2.55h0A2.56,2.56,0,0,0,322.29,150.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.61,
    cy: 148.12,
    r: 4.02,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.13,148.12a4,4,0,1,1-4-4A4,4,0,0,1,251.13,148.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.33,
    y: 144.01,
    width: 8.23,
    height: 8.23,
    rx: 1.6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.44,149.39h-9.6a1.27,1.27,0,0,1-1.27-1.27h0a1.27,1.27,0,0,1,1.27-1.27h9.6a1.27,1.27,0,0,1,1.27,1.27h0A1.27,1.27,0,0,1,152.44,149.39Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,149.39h-9.6a1.27,1.27,0,0,1-1.27-1.27h0a1.27,1.27,0,0,1,1.27-1.27h9.6a1.28,1.28,0,0,1,1.28,1.27h0A1.28,1.28,0,0,1,171.18,149.39Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,149.39h-9.6a1.28,1.28,0,0,1-1.28-1.27h0a1.28,1.28,0,0,1,1.28-1.27h9.6a1.27,1.27,0,0,1,1.27,1.27h0A1.27,1.27,0,0,1,189.93,149.39Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,149.39h-9.6a1.28,1.28,0,0,1-1.28-1.27h0a1.28,1.28,0,0,1,1.28-1.27h9.6a1.27,1.27,0,0,1,1.27,1.27h0A1.27,1.27,0,0,1,208.67,149.39Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-106"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.28,
    y: 170.36,
    width: 223.92,
    height: 80.22,
    rx: 10.58,
    transform: "matrix(1, -0.03, 0.03, 1, -7, 10.71)",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.61,216.49l-63.19,2.16a6.19,6.19,0,0,1-6.38-6h0a6.19,6.19,0,0,1,6-6.38l63.19-2.16a6.19,6.19,0,0,1,6.38,6h0A6.17,6.17,0,0,1,285.61,216.49Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.82,236l-41.76,1.42a6.19,6.19,0,0,1-6.38-5.95h0a6.19,6.19,0,0,1,6-6.38l41.75-1.43a6.19,6.19,0,0,1,6.38,6h0A6.19,6.19,0,0,1,264.82,236Z",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.8,212.56l1.81,5.61,6.64-6.08a43,43,0,0,0-4.28-2.51,2.28,2.28,0,0,0-3.08.94Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.2 222.79 428.06 216.11 425.25 212.09 418.61 218.17 425.2 222.79",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.39,171.34c-3.41,4.59-6.94,8.9-10.71,13.15a142.08,142.08,0,0,1-12.1,12.21l-.24.21-.48.39a10.27,10.27,0,0,1-1,.69,9.22,9.22,0,0,1-2.24.86,9.84,9.84,0,0,1-3.9.12,17.56,17.56,0,0,1-5.33-1.88,43,43,0,0,1-7.54-5.31A88.59,88.59,0,0,1,298,179.23l4-3.79c4.16,3.39,8.52,6.77,12.88,9.64a39.29,39.29,0,0,0,6.48,3.56,7.8,7.8,0,0,0,2.55.66c.25,0,.37-.05.22-.05a.79.79,0,0,0-.31.09.77.77,0,0,0-.18.1l-.08.05.13-.14c1.83-1.86,3.6-3.86,5.38-5.86s3.5-4.1,5.23-6.18c3.44-4.18,6.89-8.48,10.2-12.68Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.21 166.72 290.42 168.31 294.25 175.13 301.18 169.76 298.21 166.72",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.16,176.86l-1-7.1-6.93,5.37s1.07,6.18,6,6.18Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.68,175.44a.76.76,0,0,0-.75.75,1,1,0,0,0,0,.17.73.73,0,0,0-.33-.08.75.75,0,0,0-.75.75.8.8,0,0,0,.05.21h-.05a.76.76,0,0,0-.75.75.74.74,0,0,0,.16.44h0a.75.75,0,0,0-.75.75.79.79,0,0,0,.16.45.74.74,0,0,0-.6.72.76.76,0,0,0,.31.59.74.74,0,0,0-.5.7.75.75,0,0,0,1.5,0,.72.72,0,0,0-.3-.59.75.75,0,0,0,.49-.7.79.79,0,0,0-.16-.45.74.74,0,0,0,.6-.72.76.76,0,0,0-.16-.44h0a.74.74,0,0,0,.75-.75.78.78,0,0,0,0-.21h0a.75.75,0,0,0,.75-.75,1,1,0,0,0,0-.17.72.72,0,0,0,.32.08.75.75,0,0,0,0-1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,163.73c2.33,4.12,4.57,8.28,6.76,12.48s4.33,8.41,6.42,12.66l.78,1.59.66,1.3.77,1.35.87,1.39c1.21,1.85,2.5,3.75,3.84,5.63l8.15,11.42-4,3.8a123.29,123.29,0,0,1-10.7-9.75c-1.69-1.74-3.36-3.53-5-5.48l-1.19-1.49L400.32,197c-.37-.58-.8-1.24-1.12-1.77l-.91-1.52c-2.44-4-4.81-8.13-7.15-12.23s-4.61-8.24-6.8-12.42Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,135.32c.13.58-.08,1.12-.45,1.22s-.78-.3-.91-.88.09-1.13.46-1.22S356.15,134.74,356.27,135.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24,136.43a21.94,21.94,0,0,1-1.69,5.65,3.35,3.35,0,0,0,2.86-.17Z",
    style: {
      fill: "#630f0f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.74,131.79a.37.37,0,0,1-.29-.14.35.35,0,0,1,.09-.49,3.41,3.41,0,0,1,3.15-.24.36.36,0,0,1,.19.46.35.35,0,0,1-.46.19,2.71,2.71,0,0,0-2.48.16A.36.36,0,0,1,354.74,131.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,137.16c.65,6.76-.31,13.3,1.21,19.17,0,0-1.68,5.45-11.67,5.45-11,0-5-5.45-5-5.45,6-1.43,6.07-5.87,5.19-10.05Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.79,158.2c.86-1.72,1.8-3.7,0-4.32-1.94-.68-12.71-1.37-16.48-.09a4,4,0,0,0-2.86,4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,404.07a9.12,9.12,0,0,0,2-.72.19.19,0,0,0,.11-.18.23.23,0,0,0-.13-.17c-.32-.11-3.19-1.13-4-.5a.62.62,0,0,0-.21.59,1.15,1.15,0,0,0,.6.9A2.35,2.35,0,0,0,400.2,404.07Zm1.4-.86c-1.27.55-2.31.72-2.81.45a.77.77,0,0,1-.4-.62c0-.15,0-.21.07-.24C398.86,402.47,400.45,402.83,401.6,403.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.16,403.37l.09-.05a.19.19,0,0,0,.05-.19c0-.1-.7-2.32-1.77-2.87a1,1,0,0,0-.84-.07h0a.62.62,0,0,0-.49.61c0,.91,2,2.3,2.86,2.56Zm-2.27-2.85a.66.66,0,0,1,.47.08,4.59,4.59,0,0,1,1.45,2.26c-.94-.44-2.22-1.53-2.23-2.07,0-.05,0-.16.23-.24h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.67,409.31a9.17,9.17,0,0,0,2.1-.29.18.18,0,0,0,.14-.15.18.18,0,0,0-.08-.19c-.29-.19-2.88-1.78-3.77-1.32a.6.6,0,0,0-.33.54,1.16,1.16,0,0,0,.4,1A2.38,2.38,0,0,0,348.67,409.31Zm1.55-.56c-1.36.28-2.41.23-2.85-.14a.78.78,0,0,1-.26-.69c0-.15.07-.2.12-.22C347.69,407.46,349.17,408.15,350.22,408.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,409a.19.19,0,0,0,.1,0,.21.21,0,0,0,.09-.18c0-.1-.2-2.41-1.14-3.17a1.05,1.05,0,0,0-.81-.25h0a.62.62,0,0,0-.6.5c-.17.9,1.44,2.65,2.27,3.1A.14.14,0,0,0,350.73,409Zm-1.62-3.26a.67.67,0,0,1,.43.17,4.54,4.54,0,0,1,.95,2.52c-.82-.63-1.85-2-1.75-2.49,0-.05,0-.16.28-.19h.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.37 408.74 352.02 408.74 351.95 391.73 359.29 391.73 359.37 408.74",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.71 401.56 403.52 403.09 397.01 387.08 404.2 385.55 410.71 401.56",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.87,402.36l8.07-1.72a.63.63,0,0,1,.7.36l2.53,6.14a1.13,1.13,0,0,1-.83,1.51c-2.83.55-4.22.68-7.77,1.44-2.19.46-6.65,1.65-9.66,2.29s-3.93-2.28-2.75-2.82c5.33-2.4,7.12-4.52,8.62-6.51A1.83,1.83,0,0,1,402.87,402.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1,407.89h8a.6.6,0,0,1,.61.5l1.2,6.53a1.11,1.11,0,0,1-1.11,1.3c-2.89,0-7.06-.21-10.7-.21-4.26,0-7.94.23-12.93.23-3,0-3.73-3.05-2.46-3.33,5.8-1.25,10.5-1.39,15.58-4.45A3.54,3.54,0,0,1,352.1,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,158c6.83,1.58,14,20.35,14,20.35l-14.19,9.48a110.51,110.51,0,0,1-8.54-15.53C379,163.7,384.47,156.38,391.44,158Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.05,170l5.87,17.41-.67.45s-2.68-4-5.53-9.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.61,190.81c.06,8.2.55,18.4,1.77,31.06h39.3c.51-6-2.15-35.46,4.76-63.88a101.07,101.07,0,0,0-13.09-1.66,145.28,145.28,0,0,0-16.7,0,74.84,74.84,0,0,0-11.37,2s-3.37,3.64-4.38,20.71C345.7,182.45,345.59,186.33,345.61,190.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.61,190.81c2.38-4.34,6.7-13.05,6.09-18l-5.8,6.28C345.7,182.45,345.59,186.33,345.61,190.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,165c.62,7-15.25,23.84-15.25,23.84L330,178.49A82,82,0,0,1,341.9,163C349.34,155.8,357.28,157.17,358,165Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "351.95 391.73 351.98 400.5 359.33 400.5 359.3 391.73 351.95 391.73"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "404.2 385.56 397.01 387.09 400.37 395.34 407.56 393.81 404.2 385.56"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,129.25c1.07,7.23,2.06,11.4-.72,15.95a9.49,9.49,0,0,1-16.79-.89c-2.87-6-4.15-16.84,2.16-21.42A9.58,9.58,0,0,1,375.18,129.25Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,135.35c-3.63.61-5.67-3.56-2.88-7.13-5.29.24-7.54-2.47-5.18-7.31,2-4.17,8.39-2.13,8.39-2.13s5.32-7.15,11.61-3.17c6.75,4.27,3.17,8.22,3.17,8.22s9.69,1.34,7.19,8.3a6.09,6.09,0,0,1-5,4s2.48,7.46-4.87,9S359.66,140.53,362,135.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.23,133.49a8.63,8.63,0,0,1-1.31,5.22c-1.31,2-3.11,1.25-3.69-.84-.53-1.88-.49-5.21,1.28-6.53S364,131.29,364.23,133.49Z",
    style: {
      fill: "#7f3e3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.32,221.87S367.49,278,371.26,299c4.12,23,25.47,95.33,25.47,95.33l13.16-2.8s-14.69-67.63-16.67-90.44c-2.15-24.75-6.54-79.26-6.54-79.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.79,389.93c-.06,0,2.24,4.81,2.24,4.81l14.8-3.15-1.06-4.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.82,241.87c9.57,1.89,7.16,37.84,5.29,56.33-2.28-13.07-5.38-38.22-7.47-56.07A3.34,3.34,0,0,1,365.82,241.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.39,221.87s-3.14,54.93-3.2,77.33c-.07,23.3,5.12,99.6,5.12,99.6h12.45s3.35-74.94,4.78-97.82c1.57-25,6.68-79.11,6.68-79.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.61,216.67a14,14,0,0,0,.89,5.2,24.52,24.52,0,0,0-.45,4.55c4,1.41,41.78,3.16,41.7,0s0-4.55,0-4.55,1-4.45,0-5.2S345.89,214,345.61,216.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.61,216.67a14,14,0,0,0,.89,5.2,24.52,24.52,0,0,0-.45,4.55c4,1.41,41.78,3.16,41.7,0s0-4.55,0-4.55,1-4.45,0-5.2S345.89,214,345.61,216.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.11,393.84c-.06,0,.5,5.17.5,5.17h15.14l.59-4.61Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteSetupProject1);
export default __webpack_public_path__ + "static/media/website-setup-project-1.a7daad0ec5cc660c036d488aee49217f.svg";
export { ForwardRef as ReactComponent };